import { useEffect, useCallback } from "react";
import { useRefsContext } from "@/contexts/ref";
import { InteractionEnum } from "@/types";
import { useCustomerAction } from "@/hooks";
export const useSectionObserver = () => {
    const context = useRefsContext();
    const { customerActionExposeInteraction } = useCustomerAction();
    // eslint-disable-next-line no-restricted-globals
    const isElementVisible = useCallback((element) => {
        const rect = element ? element.getBoundingClientRect() : null;
        // eslint-disable-next-line no-restricted-globals
        return rect && rect.top < window.innerHeight && rect.bottom >= 0;
    }, []);
    const elementSection = (sectionRef) => sectionRef &&
        "current" in sectionRef &&
        // eslint-disable-next-line no-restricted-globals
        (sectionRef === null || sectionRef === void 0 ? void 0 : sectionRef.current) instanceof HTMLElement
        ? sectionRef === null || sectionRef === void 0 ? void 0 : sectionRef.current
        : null;
    useEffect(() => {
        const handleScroll = () => {
            Object.entries(context).forEach(([sectionName, sectionRef]) => {
                if (isElementVisible(elementSection(sectionRef))) {
                    customerActionExposeInteraction([
                        { interaction: InteractionEnum.SCROLLING },
                        { value: sectionName.replace("Ref", "") },
                    ], `CustomerActionScrollSection-${sectionName.replace("Ref", "")}`);
                }
            });
        };
        // eslint-disable-next-line no-restricted-globals
        window.addEventListener("scroll", handleScroll);
        return () => {
            // eslint-disable-next-line no-restricted-globals
            window.removeEventListener("scroll", handleScroll);
        };
    }, [context, isElementVisible, customerActionExposeInteraction]);
};
